import { generateDataEntries } from './generateDataEntries';
import { hasAny } from './hasAny';

const data = {
  generateDataEntries,
  hasAny,
};

export { data };
